<script>
  import '../project-detail-preview/projectDetailPreview.css'
  import Viewer from '../../../../utils/tui-editor/Viewer.svelte'

  export let source
</script>

<div class="detail-preview">

  <Viewer {source} />

</div>
